const useIsDev = () => {
  return (
    window.location.href.includes("http://localhost:3000/") ||
    window.location.href.includes(".vercel.app")
  );
};
export default useIsDev;
